import { render } from "./DashboardModeToggle.vue?vue&type=template&id=55b35150&scoped=true"
import script from "./DashboardModeToggle.vue?vue&type=script&lang=js"
export * from "./DashboardModeToggle.vue?vue&type=script&lang=js"

import "./DashboardModeToggle.vue?vue&type=style&index=0&id=55b35150&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55b35150"]])

export default __exports__